export enum LocationType {
  Origen = 'Origen',
  Destino = 'Destino'
}